import React from 'react';
import Navbar from '../components/site/Navbar';
import Footer from '../components/site/Footer';
import Seo from '../components/Seo';
import { Button } from '../components/ui/button';
import { Download, Newspaper, Mail, Calendar } from 'lucide-react';

const NEWS = [
  { date: 'June 2026', tag: 'Milestone', title: 'Hipro Technologies crosses 1000+ delivered projects', text: 'A decade of delivery across India, USA and UK — spanning software, AI automation and digital growth for 800+ clients.' },
  { date: 'March 2026', tag: 'Expansion', title: 'Global team grows past 1800 technology professionals', text: 'Follow-the-sun delivery strengthened with expanded engineering hubs in Pune, Hyderabad, Bangalore and Gurgaon.' },
  { date: 'January 2026', tag: 'Product', title: 'Careers Booster and AI screening launch on hiprotechnologies.com', text: 'Candidates now get AI-assisted application screening and one-click apply across all open roles.' },
  { date: '2023', tag: 'Practice Launch', title: 'AI & Automation division launched', text: 'Dedicated practice for chatbots, document intelligence and ML — now among the fastest-growing service lines.' },
  { date: '2021', tag: 'Certification', title: 'ISO/IEC 27001 information security certification', text: 'Enterprise-grade security management formalised across all delivery centres.' },
];

const FACTS = [
  ['Founded', '2015, Pune (India)'], ['Tagline', 'Innovate. Build. Scale'],
  ['Team', '1800+ technology professionals worldwide'], ['Projects', '1000+ delivered'],
  ['Clients', '800+ across 14+ countries'], ['Offices', '13 — across 7 countries'],
];

export default function PressPage() {
  return (
    <div className="min-h-screen bg-white text-slate-900">
      <Seo
        title="Press & Media | Hipro Technologies"
        description="Hipro Technologies in the news: company announcements, milestones, brand assets and media contact. Download the official brand kit."
        path="/press"
      />
      <Navbar />
      <section className="pt-28 pb-12 bg-slate-950 text-white">
        <div className="max-w-4xl mx-auto px-5 lg:px-8 text-center">
          <span className="text-xs font-semibold uppercase tracking-widest text-orange-400">Press & Media</span>
          <h1 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold">Hipro in the News</h1>
          <p className="mt-4 text-slate-300">Announcements, milestones and everything journalists need to cover Hipro Technologies.</p>
          <div className="mt-7 flex flex-wrap justify-center gap-3">
            <a href="/brand-kit.zip" download data-testid="brand-kit-download">
              <Button className="bg-orange-500 hover:bg-orange-600 h-11 px-6 rounded-full"><Download className="h-4 w-4 mr-1.5" /> Download brand kit</Button>
            </a>
            <a href="mailto:info@hiprotechnologies.com?subject=Media%20enquiry">
              <Button variant="outline" className="h-11 px-6 rounded-full border-white/20 bg-transparent text-white hover:bg-white/10"><Mail className="h-4 w-4 mr-1.5" /> Media enquiries</Button>
            </a>
          </div>
        </div>
      </section>

      <section className="py-14">
        <div className="max-w-3xl mx-auto px-5 lg:px-8 space-y-5" data-testid="press-news-list">
          {NEWS.map((n) => (
            <article key={n.title} className="rounded-2xl border border-slate-200 p-6 hover:border-orange-300 transition-colors">
              <div className="flex items-center gap-3 text-xs">
                <span className="font-bold uppercase tracking-wider text-orange-600 bg-orange-50 border border-orange-200 rounded-full px-2.5 py-0.5">{n.tag}</span>
                <span className="flex items-center gap-1 text-slate-500"><Calendar className="h-3.5 w-3.5" /> {n.date}</span>
              </div>
              <h2 className="mt-3 text-lg font-extrabold flex items-start gap-2"><Newspaper className="h-5 w-5 text-orange-500 shrink-0 mt-0.5" /> {n.title}</h2>
              <p className="mt-2 text-sm text-slate-600">{n.text}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="py-14 bg-slate-50">
        <div className="max-w-3xl mx-auto px-5 lg:px-8">
          <h2 className="text-2xl font-extrabold text-center">Fast facts</h2>
          <div className="mt-8 grid sm:grid-cols-2 gap-4">
            {FACTS.map(([k, v]) => (
              <div key={k} className="rounded-xl border bg-white p-4">
                <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">{k}</div>
                <div className="mt-1 font-bold text-slate-900">{v}</div>
              </div>
            ))}
          </div>
          <p className="mt-8 text-center text-sm text-slate-500">Media contact: <a className="text-orange-600 font-semibold hover:underline" href="mailto:info@hiprotechnologies.com">info@hiprotechnologies.com</a> · Phone: +91 93598 19036</p>
        </div>
      </section>
      <Footer />
    </div>
  );
}
